export const buildInfo: { gitHash: string; dateTime: number | 'local' } = { gitHash: '441d9dc', dateTime: 1774899359514 };